// extracted by mini-css-extract-plugin
module.exports = {"selector":"productScreen_selector__ixP45"};